export default {
  userContext: {},
  forms: [],
  completed: false,
  currentForm: null
}
